import { Divider, Stack, Typography } from '@mui/material';
import { AccordionNumberedStepper } from 'Components/AccordionNumberedStepper';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { RoutesConfig } from 'Routes';
import { OrderRegularMedications } from './OrderRegularMedications';
import { Title } from './Title';
import { FourSegment } from './FourSegment';
import { ContactUsSegment } from 'Modules/Equipment/EquipmentMain/EquipmentNotAllowed/ContactUsSegment';

interface INewUserInformationProps {
  isNoValidrMedications: boolean;
}

export const NewUserInformation = (props: INewUserInformationProps) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const medicationsHistoryDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsHistory
  );

  const { isNoValidrMedications } = props;

  return (
    <Stack pb={2} maxWidth='960px'>
      <LinkReturnToMain
        label={
          isNoValidrMedications ? medicationsHistoryDictionary.titleLink : ''
        }
        link={
          isNoValidrMedications
            ? RoutesConfig.MEDICATION_AND_PRESCRIPTIONS_LOBBY.PATH
            : ''
        }
      />
      <Title
        title={
          isNoValidrMedications
            ? dictionary.requestNewMedication
            : dictionary.newUserTitle
        }
        subtitle={
          isNoValidrMedications
            ? dictionary.userHasNoRegularMedicationsSubTitle
            : dictionary.newUserSubTitle
        }
      />
      <OrderRegularMedications isNoValidrMedications={isNoValidrMedications} />

      <FourSegment
        steps={[
          dictionary.aDoctorWillCheckYourRequest,
          dictionary.ifApprovedYouWillBeNotified,
          dictionary.youWillBeAbleToOrderHere,
        ]}
      />
      <ContactUsSegment />
    </Stack>
  );
};
